import authActionTypes from "./auth";
import productActionTypes from "./products";
import orderActionTypes from "./orders";
import automationActionTypes from "./automations";
import settingActionTypes from "./settings";
import shopActionTypes from "./shop";
import statActionTypes from "./stat";
import bisNotificationsActionTypes from "./bisNotifications";
import integrationsActionTypes from "./integrations";
import sellingPlansActionTypes from "./sellingPlans";
import activityLogsActionTypes from "./activityLogs";
import automationTagsActionTypes from "./automationTags";

const types = {
  ...authActionTypes,
  ...automationActionTypes,
  ...productActionTypes,
  ...orderActionTypes,
  ...settingActionTypes,
  ...shopActionTypes,
  ...statActionTypes,
  ...bisNotificationsActionTypes,
  ...integrationsActionTypes,
  ...sellingPlansActionTypes,
  ...activityLogsActionTypes,
  ...automationTagsActionTypes,
};

export default types;
